/**
 * Client mirror of the LOCAL player's NECK accessory slot (itemId, "" = empty). Fed from the synced
 * Player.neck in world3d; the inventory paperdoll subscribes to show the worn charm.
 */
type Listener = (itemId: string) => void;

class NeckStore {
  private itemId = "";
  private readonly listeners = new Set<Listener>();

  get(): string { return this.itemId; }

  set(itemId: string): void {
    if (itemId === this.itemId) return;
    this.itemId = itemId;
    for (const fn of this.listeners) fn(this.itemId);
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.itemId);
    return () => this.listeners.delete(fn);
  }
}

export const neckStore = new NeckStore();
